import { Box, Skeleton, Typography, useTheme } from '@mui/material'

type GuideNavbarSkeletonProps = {
  navCount?: number
  searchWidth?: number
  searchHeight?: number
  isError?: boolean
}

export function GuideNavbarSkeleton({
  navCount = 6,
  searchWidth = 420,
  searchHeight = 44,
  isError,
}: GuideNavbarSkeletonProps) {
  const theme = useTheme()

  const widths = [68, 92, 84, 110, 76, 96, 72, 88]

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        display: 'flex',
        height: '70px',
        py: 0,
        pr: '20px',
        pl: '24px',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexShrink: 0,
        borderBottom: '1px solid #d6d6d6',
        backgroundColor: theme.palette.common.white,
        backdropFilter: 'saturate(180%) blur(6px)',
      }}
    >
      {/* Left: tablist */}
      <Box
        role="tablist"
        sx={{
          display: 'flex',
          alignItems: 'center',
          columnGap: '32px',
          alignSelf: 'stretch',
        }}
      >
        {!isError ? (
          Array.from({ length: navCount }).map((_, i) => (
            <Skeleton
              key={i}
              variant="rounded"
              // Mimic a pill/tab
              sx={{
                borderRadius: '999px',
                flexShrink: 0,
              }}
              width={widths[i % widths.length]}
              height={32}
            />
          ))
        ) : (
          <Typography variant="body2">Something went wrong.</Typography>
        )}
      </Box>

      <Box
        sx={{
          width: `${searchWidth}px`,
          height: `${searchHeight}px`,
          display: 'flex',
          alignItems: 'center',
          border: '1px solid #d6d6d6',
          borderRadius: '8px',
          overflow: 'hidden',
          flexShrink: 0,
        }}
      >
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </Box>
    </Box>
  )
}
